import { CELL, GRID_SIZE } from './constants';
import type { Point } from './types';

/** Chebyshev distance — the metric wires reach by. */
export const cheb = (a: Point, b: Point): number =>
  Math.max(Math.abs(a.r - b.r), Math.abs(a.c - b.c));

/** Canonical map key for a cell. */
export const key = (p: Point): string => p.r + ',' + p.c;

/** Inverse of {@link key}. */
export function parseKey(k: string): Point {
  const [r, c] = k.split(',');
  return { r: Number(r), c: Number(c) };
}

export const inBounds = (p: Point): boolean =>
  p.r >= 0 && p.r < GRID_SIZE && p.c >= 0 && p.c < GRID_SIZE;

/** Board-unit centre of a cell. */
export const cx = (p: Point): number => p.c * CELL + 50;
export const cy = (p: Point): number => p.r * CELL + 50;

/** Straight-line wire length between two cell centres, in board units. */
export const wireLength = (a: Point, b: Point): number => Math.hypot(cx(a) - cx(b), cy(a) - cy(b));

export const samePoint = (a: Point, b: Point): boolean => a.r === b.r && a.c === b.c;

export const clonePoint = (p: Point): Point => ({ r: p.r, c: p.c });
